import { render, staticRenderFns } from "./SactinFaceAttentance.vue?vue&type=template&id=ab99c874&scoped=true&"
import script from "./SactinFaceAttentance.vue?vue&type=script&lang=js&"
export * from "./SactinFaceAttentance.vue?vue&type=script&lang=js&"
import style0 from "./SactinFaceAttentance.vue?vue&type=style&index=0&id=ab99c874&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab99c874",
  null
  
)

export default component.exports